export default "__VITE_ASSET__Cfqr6FRS__"